<template>
    <div class="wl-certify-standard-detail">
        <div class="wl-breadcrumb-trail">
           <div class="crumbs-text">
               <i class="wl-icon-zhuye1"></i>
               <span>当前位置：</span>
               <span @click="goHome">首页</span> 
               <span>></span>
               <span @click="goCertify">申请标准</span>
               <span>></span>
               <span>{{showTitle}}</span>
           </div>
        </div>
        <div class="standard-introduce-content clearfix">
            <div class="standard-list-left">
                <div class="standard-list-li" @click="getShow(item.Id)" v-for="(item,index) in list" :key="index">
                    <div class="standard-hade">
                        <i class="wl-icon-quanbu"></i>
                        <span>{{item.name}}</span>
                    </div>
                    <div class="text-list-li" v-show="authenticationId == item.Id" v-for="(child,chIndex) in item.NodeNames" :key="chIndex">
                        <p>{{child.Title}}</p>
                    </div>
                </div>
            </div>
            <div class="standard-contebt-left">
                <div class="standard-contebt-li">
                    <h3 class="h3-title-standard">{{authentication.title}}申请标准</h3>
                    <div class="standard-contebt-content" v-for="(child,chIndex) in authentication.authenticationNodeList" :key="chIndex">
                        <h3 class="h3-wl-title"><span class="sp-border-class"></span> <span class="sp-title-text">{{child.Title}}</span></h3>
                        <div class="exam-text-content">
                            <p>{{child.authenticationId}}</p>
                            <p v-html="child.Content" style="font-size:16px;font-family:MicrosoftYaHei;font-weight:400;color:rgba(102,102,102,1);line-height:28px;"></p>
                            <!-- <p>初级物流师认证考试（包括物联网系统工程师认证、物联网开发工程师认证、物联网系统应用技术等）项目为考生提供了检测自己对物联网所学知识掌握程度的一种有效方式，并且考生能够通过参加考试巩固所学知识，并明确自己的知识薄弱点和以后学习的方向。</p> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            imgBack1:require("assets/images/test-bg-1.png"),
            imgBack2:require("assets/images/test-bg-2.png"),
            imgBack3:require("assets/images/test-bg-3.png"),
            sample1: require('assets/images/wly.png'),
            sample2: require('assets/images/zlwls.png'),
            sample3: require('assets/images/zjwls.png'),
            sample4: require('assets/images/gjwls.png'),
            list: [],
            authentication:{},
            authenticationId:"",
            showTitle: '物流员'
        }
    },
    props:{
        id:{
            type: String
        }
    },
    created(){
        this.getAuthentication();
        this.authenticationId = this.id;
        this.getAuthenticationNodeList();
    },
    computed: {
        association: function() {
        return this.$store.state.association;
        }
    },
    methods: {
        getShow(id){
            this.authenticationId = id;
            this.getAuthenticationNodeList();
            // this.authenticationId = num;
        },
        goHome(){
            this.$router.push({
                name: 'xHome'
            })
        },
        goCertify(){
            this.$router.push({
                name:'standard'
            })
        },
        getAuthenticationNodeList(){
            var that = this;
            this.$http.post("/api/XOrg/AuthenticationShow/getAuthenticationNodeList",{
                authenticationId: this.authenticationId
            }).then(function(rst){
                that.authentication = rst.authentication;
                that.list.forEach(ele => {
                   if(ele.Id == that.authenticationId) {
                       that.showTitle = ele.name;
                   }
                });
            })
        },
        getAuthentication(){
            var that = this;
            this.$http.post("/api/XOrg/AuthenticationShow/getAuthenticationList",{
                associationId: this.association.Id
            }).then(function(rst){
                that.list = rst.authenticationList;
            })
        }
    }
}
</script>
